import React from "react";
import { Search, Keyboard } from "lucide-react";
import { useUXChrome } from "../contexts/UXChromeContext";
import NotificationBell from "./NotificationBell";
import HealthBadge from "./HealthBadge";
import ThemeToggleButton from "./ThemeToggleButton";

const isMac = typeof navigator !== "undefined" && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
const MOD_LABEL = isMac ? "⌘" : "Ctrl";

/**
 * The reusable cluster of header tools: ⌘K search button + notification bell + ? cheatsheet button.
 * Placed in both AppShell and ModuleAppShell headers and Home page.
 */
export default function HeaderTools() {
    const { setCommandOpen, setShortcutsOpen } = useUXChrome();
    return (
        <div className="flex items-center gap-1">
            <button
                onClick={() => setCommandOpen(true)}
                data-testid="header-search-btn"
                className="hidden md:flex items-center gap-2 px-3 h-9 rounded-md border bg-white text-[color:var(--asl-muted)] hover:asl-navy-text transition text-xs"
                style={{ borderColor: "var(--asl-border)" }}
                aria-label="Open search"
            >
                <Search className="h-3.5 w-3.5" />
                <span>Search…</span>
                <kbd className="mono ml-3 px-1.5 py-0.5 rounded bg-gray-100 text-[10px]">{MOD_LABEL}K</kbd>
            </button>
            <button
                onClick={() => setCommandOpen(true)}
                data-testid="header-search-icon-btn"
                className="md:hidden h-9 w-9 rounded-full flex items-center justify-center hover:bg-gray-100 asl-navy-text"
                aria-label="Search"
            >
                <Search className="h-4 w-4" />
            </button>
            <NotificationBell />
            <HealthBadge />
            <ThemeToggleButton />
            <button
                onClick={() => setShortcutsOpen(true)}
                data-testid="header-shortcuts-btn"
                className="hidden lg:flex h-9 w-9 rounded-full items-center justify-center hover:bg-gray-100 asl-navy-text"
                aria-label="Keyboard shortcuts"
                title="Keyboard shortcuts (?)"
            >
                <Keyboard className="h-4 w-4" />
            </button>
        </div>
    );
}
